import React, { Component } from 'react';
import { logoutVianovaUser } from '../functions';
class Logout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            displayMenu: false
        };
        this.showDropdownMenu = this.showDropdownMenu.bind(this);
        this.hideDropdownMenu = this.hideDropdownMenu.bind(this);
    }
    showDropdownMenu(event) {
        event.preventDefault();
        this.setState({ displayMenu: true });
    }
    hideDropdownMenu() {
        this.setState({ displayMenu: false });
    }
    render() {
        return (React.createElement("div", { className: "dropdown", onClick: this.showDropdownMenu }, this.state.displayMenu ? (React.createElement("ul", null,
            React.createElement("li", { onMouseOut: this.hideDropdownMenu, onClick: () => { logoutVianovaUser(); } }, "Logout")))
            : null));
    }
}
export default Logout;
